export default {
  sihuaLu: 'additional',
  sihuaQuan: 'forceful',
  sihuaKe: 'easygoing',
  sihuaJi: 'focused',
} as const;
